
import { usePalette, brandColors as colors } from "@/lib/palette";
import Footer from "@/components/ui/Footer";
import WaveDivider from "@/components/ui/WaveDivider";
import HeroSection from "@/components/sections/HeroSection";
import CommunitySection from "@/components/sections/CommunitySection";
import ContentSection from "@/components/sections/ContentSection";
import FeaturedSection from "@/components/sections/FeaturedSection";
import ConnectSection from "@/components/sections/ConnectSection";
import NewsletterSection from "@/components/sections/NewsletterSection";
import KindWordsSection from "@/components/sections/KindWordsSection";

export default function HomePage() {
  const theme = usePalette();
  return (
    <div className="min-h-dvh" style={{ backgroundColor: colors.cream }}>
      <HeroSection />
      <WaveDivider color={theme.accentSoft} />
      <CommunitySection />
      <WaveDivider color={colors.cream} />
      <ContentSection />
      <WaveDivider color={theme.sectionBg} />
      <FeaturedSection />
      <WaveDivider color={colors.cream} />
      <KindWordsSection />
      <WaveDivider color={theme.sectionBg2} />
      <NewsletterSection />
      <ConnectSection />
      <Footer />
    </div>
  );
}
